import { BadgeIcon } from '@/shared/ui/badge-icon';
import { Card } from '@/shared/ui/card';
import { Spinner } from '@/shared/ui/spinner';

export function ActivatingCard({ planName }: { planName: string }) {
  return (
    <Card asChild>
      <section
        data-enter=""
        aria-live="polite"
        className="mx-auto mt-12 flex max-w-140 shrink grow basis-full flex-col gap-4.5 p-8"
      >
        <BadgeIcon>
          <Spinner size="lg" />
        </BadgeIcon>
        <div className="flex flex-col gap-2">
          <h1 className="font-semibold text-title">Payment received. Turning on {planName}…</h1>
          <p className="text-muted">
            This usually takes a few seconds. You can leave this page; {planName} turns on by
            itself. Paddle has sent the receipt.
          </p>
        </div>
      </section>
    </Card>
  );
}
